import React, { useEffect } from 'react';
import markerImageSrc from '../../assets/images/main_logo.png'; // 경로 수정

const Address = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=5d499da089e61ca64970818b642c4f8e&autoload=false`;
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      const { kakao } = window;

      if (kakao && kakao.maps) {
        const mapContainer = document.getElementById('map');
        const mapOption = {
          center: new kakao.maps.LatLng(36.7894850443376, 127.107421226737),
          level: 3,
        };
        const map = new kakao.maps.Map(mapContainer, mapOption);

        // 마커 이미지 크기 설정
        const markerImageSize = new kakao.maps.Size(140, 50);
        const markerImage = new kakao.maps.MarkerImage(markerImageSrc, markerImageSize);

        // 마커 위치 설정
        const markerPosition = new kakao.maps.LatLng(36.7894850443376, 127.107421226737);
        const marker = new kakao.maps.Marker({
          position: markerPosition,
          image: markerImage,
          anchor: new kakao.maps.Point(32, 69), // 마커 이미지 기준점 설정
        });

        // 마커 지도에 추가
        marker.setMap(map);
      } else {
        console.error('Kakao Maps API is not loaded');
      }
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section className="last-section">
      <div className="map-wrap">
        <div className="map-left-wrap">
          <div className="left-content">
            <h2>Contact Us</h2>
            <p>A. 충청남도 아산시 배방읍 희망로46번길 45-7, 충남글로벌게임센터 509호</p>
            <p>F. 0504-373-4873</p>
            <p>E. plassion@naver.com</p>
            <div className="map-btn-wrap">
              <div className="come-a">
                <p>오시는 길</p>
              </div>
              <div className="come-b">
                <p>문의하기</p>
              </div>
            </div>
          </div>
        </div>
        <div className="map-right-wrap" id="map"></div>
      </div>
    </section>
  );
};

export default Address;
